import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const SaveReenrollmentFormDraftMutation = graphql.persisted(
  "SaveReenrollmentFormDraft",
  graphql(`
    mutation SaveReenrollmentFormDraft($token: String!, $formData: JSON!, $currentStep: Int) {
      saveReenrollmentFormDraft(input: {token: $token, formData: $formData, currentStep: $currentStep}) {
        success
        formData
        userErrors { message path }
      }
    }
  `)
);

export { SaveReenrollmentFormDraftMutation };

export function useSaveReenrollmentFormDraft() {
  return useMutation(SaveReenrollmentFormDraftMutation);
}
